import { createFileRoute } from "@tanstack/react-router";

import { prefetchForProject } from "../../lib/prefetch";
import { TasksPage } from "../../workspaces/projects/pages/TasksPage";
import { useProjectId } from "../../shell/project";

export const Route = createFileRoute("/_console/p/$org/$project/tasks/")({
  loader: ({ context: { queryClient }, params }) =>
    prefetchForProject(
      queryClient,
      params,
      import("../../workspaces/projects/queries"),
      ({ projectTasksQuery }, projectId) =>
        queryClient.prefetchQuery(projectTasksQuery(projectId)),
    ),
  component: ProjectTasksRoute,
});

function ProjectTasksRoute() {
  return <TasksPage projectId={useProjectId()} />;
}
